import React, { useEffect } from 'react';

const ExternalRedirect = ({ url }) => {
  useEffect(() => {
    window.location.replace(url);
  }, [url]);

  return <div>Redirecting to EduSkills Login...</div>;
};

export default ExternalRedirect;